<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import {couponConf} from "@/utils/config";
import router from "@/router";
import {useRoute} from "vue-router";
import axiosApi from "@/utils/axiosApi";
import OrderDetails from "@/components/sqwl/orderDetails.vue";

// const type = computed(() => couponConf.jdxc)
const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf["meland-xmair"];
    }
  }
});
const coupSelected = ref(0);
const stepImg = require("@/assets/images/meland/recharge-step.png")
watch(() => props.couponLst, () => {
  coupSelected.value = 0;
})
const orderFlag = ref(false)
const route = useRoute()
const orderDat = ref({})
onMounted(()=>{
  // orderFlag.value = !!route.query.order
  if(route.query.order){
    new axiosApi({
      encode: "site",
      method: "coupon/orderDetails",
      body: {
        ordersn: route.query.order
      }
    }).send(res => {
      if (res.message.code === "000") {
        orderFlag.value = true
        orderDat.value = res.data
      } else  orderFlag.value = false
    },()=>orderFlag.value=false)
  }
})

const subDiscount = cou => {
  let discount = parseFloat((parseFloat(cou.pay_score) / parseFloat(cou.face_value) * 10).toFixed(1))
  return discount + '折'
}
const rechargeStep = ref('waiting_recharge')
</script>

<template>
  <div class="coupon-list">
    <div class="product-header">
      <div class="bottom-header">
        <el-image :src="props.type?.headerImg"/>
      </div>
    </div>
    <div class="coupon-lst" v-if="props.couponLst.length">
      <div class="coupon-items" :class="props.type.login" v-for="coupon in props.couponLst[0].data" :key="coupon.id">
        <div class="coupon-items-left">
          <el-image :src="props.type.miniLogo"/>
          <div class="coupon-items-price">价值{{ parseFloat(coupon.face_value) }}元起</div>
        </div>
        <div class="coupon-items-right">
          <h4>{{ coupon.name }}</h4>
          <div class="coupon-info">
            <div class="coupon-items-contents">
              <div class="coupon-prices">
                <el-text :type="props.type.login==='xm_air'?'primary':'danger'" class="totalPrice">
                  {{ coupon?.score_data[props.type.login].total }}
                </el-text>
                <span class="discount">{{ subDiscount(coupon) }}</span>
                <span style="font-size: .7rem">{{ props.type.login === 'xm_air' ? '积分' : '里程' }}</span>
                <div class="discount-price">
                  <el-text type="info">{{
                      coupon?.score_data[props.type.login]?.discount
                    }}{{ props.type.login === 'xm_air' ? '积分' : '里程' }}
                  </el-text>
                </div>
              </div>
            </div>
            <div class="button">
              <el-button :type=" props.type.login === 'xm_air'?'primary':'danger'" round
                         v-if="Object.keys(props.account).length < 1 || parseFloat(props.account.balance_miles) >= coupon?.score_data?.[props.type.login]?.total "
                         @click="router.push({name:'detail',params:{id:coupon.id},query:{contents: 'recharge'}})">
                立即兑换
              </el-button>
              <el-button type="info" round v-else disabled>{{
                  props.type.login === 'xm_air' ? '积分' : '里程'
                }}不足
              </el-button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="recharge-step-items">
    <div class="recharge-step-items-tabs" :class="rechargeStep">
      <div class="step-item-1" @click="rechargeStep='waiting_recharge'"></div>
      <div class="step-item-1" @click="rechargeStep='real_recharge'"></div>
    </div>
    <div class="recharge-step-items-content">
      <div class="recharge-content" v-if="rechargeStep === 'waiting_recharge'">
        <div class="recharge-content-its" v-for="(cont,inx) in type.desc" :key="inx">
          <h3 v-if="cont.title.length">{{ cont.title }}</h3>
          <ol class="recharge-content-val">
            <li v-for="(conte,inx) in cont.content" :key="inx" v-html="conte"></li>
          </ol>
        </div>
      </div>
      <div class="real-content" v-if="rechargeStep === 'real_recharge'">
        <el-image :src="stepImg"/>
      </div>
    </div>
  </div>
  <order-details v-if="orderFlag" :order-dat="orderDat" :order-flag="orderFlag" @close="router.replace({name:'home'}),orderFlag=false" :type="props.type"/>
</template>

<style scoped lang="less">
.coupon-list {
  padding: 10px;
  background: #fff;
  border-radius: 12px;
  margin: 20px 15px 15px;
  box-shadow: var(--el-box-shadow);
  position: relative;

  .coupon-lst {
    margin-top: 25px;

    .coupon-items {
      //background-image: url("@/assets/images/sqwl/coupon.png");
      margin-bottom: 15px;
      border-radius: 12px;
      padding: 10px;
      //height: 80px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;

      &.xm_air {
        background-image: url("@/assets/images/meland/coupon.png");
      }
      &.scal {
        background-image: url("@/assets/images/meland/scal.png");
      }

      .coupon-items-left {
        width: 21%;
        flex-basis: 21%;
        text-align: center;
        box-sizing: border-box;
        align-items: center;
        margin-top: 15px;
        margin-right: 20px;

        .el-image {
          width: 100%;
          border-bottom: 1px dashed #ffffff;
          padding-bottom: 5px;
        }

        .coupon-items-price {
          margin-bottom: 10px;
          color: #ffffff;
          font-size: .7rem;
          //禁止换行
          white-space: nowrap;
        }
      }

      .coupon-items-right {
        flex-basis: calc(80% - 20px);
        width: calc(80% - 20px);
        .coupon-info{
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
        }

        .coupon-items-contents {
          flex-basis: 75%;
          width: 75%;

          .coupon-prices {
            position: relative;
            margin-top: 10px;


            .totalPrice {
              font-size: 1.45rem;
            }

            .discount {
              background-color: #D8000D;
              color: white;
              padding: 3px 8px;
              border-radius: 12px;
              font-size: 0.6rem;
              position: absolute;
              top: -9px;
              //left: 6rem;
              z-index: 1;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

              &:after {
                content: '';
                position: absolute;
                bottom: 4px;
                left: -8px;
                border-width: 5px;
                border-style: solid;
                border-color: transparent #D8000D transparent transparent;
              }
            }

            .discount-price {
              .el-text {
                //删除线
                text-decoration: line-through;
              }
            }
          }
        }

      }
    }
  }
}

.recharge-step-items {
  padding: 15px;

  .recharge-step-items-tabs {
    background-repeat: no-repeat;
    height: 60px;
    background-size: 100%;
    display: flex;
    position: relative;
    z-index: 9;

    &.waiting_recharge {
      background-image: url("@/assets/images/meland/waiting.png");
    }

    &.real_recharge {
      background-image: url("@/assets/images/meland/recharge.png");
    }

    .step-item-1 {
      flex-basis: 50%;
      height: 60px;
      width: 50%;
    }


  }

  .recharge-step-items-content {
    box-sizing: border-box;
    padding: 15px;
    background: #fff;
    margin-top: -20px;
    border-radius: 0 0 12px 12px;

    .recharge-content {
      //padding-left: 15px;
      line-height: 1.8;
      text-align: justify;

      .recharge-content-its {
        padding: 15px;

        h3 {
          margin-bottom: 15px;
        }

        & + .recharge-content-its {
          border-top: 3px dashed #e5e5e5;
        }

        .recharge-content-val {
          font-size: .85rem;
        }
      }
    }
  }

  .real-content {
    padding: 10px;
    border: 1px solid #AE8C49;
    border-radius: 12px;
    margin-top: 15px;

    .el-image {
      padding: 10px;
      background: #AE8C49;
      border-radius: 12px;
    }
  }
}
</style>
